import { render } from "./TransferResult.vue?vue&type=template&id=041df88c&scoped=true"
import script from "./TransferResult.vue?vue&type=script&lang=js"
export * from "./TransferResult.vue?vue&type=script&lang=js"

import "./TransferResult.vue?vue&type=style&index=0&id=041df88c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041df88c"]])

export default __exports__